// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__18C76","info":"UpdateTermsInfo_info__Dmt7J"};